import React, { useEffect, useState } from 'react';

const Confetti = ({ isActive, duration = 3000 }) => {
    const [particles, setParticles] = useState([]);

    useEffect(() => {
        if (isActive) {
            const colors = ['#f59e0b', '#f97316', '#ef4444', '#22c55e', '#3b82f6', '#a855f7', '#ec4899'];
            const newParticles = [];
            
            for (let i = 0; i < 100; i++) {
                newParticles.push({
                    id: i,
                    x: Math.random() * 100,
                    delay: Math.random() * 0.5,
                    duration: 2 + Math.random() * 2,
                    color: colors[Math.floor(Math.random() * colors.length)],
                    size: 8 + Math.random() * 8,
                    rotation: Math.random() * 360,
                });
            }
            
            setParticles(newParticles);
            
            const timer = setTimeout(() => {
                setParticles([]);
            }, duration);
            
            return () => clearTimeout(timer);
        }
    }, [isActive, duration]);

    if (!isActive || particles.length === 0) return null;

    return (
        <div className="fixed inset-0 pointer-events-none z-[200] overflow-hidden">
            {particles.map((particle) => (
                <div
                    key={particle.id}
                    className="absolute animate-confetti"
                    style={{
                        left: `${particle.x}%`,
                        top: '-20px',
                        width: particle.size,
                        height: particle.size,
                        backgroundColor: particle.color,
                        borderRadius: Math.random() > 0.5 ? '50%' : '2px',
                        transform: `rotate(${particle.rotation}deg)`,
                        animationDelay: `${particle.delay}s`,
                        animationDuration: `${particle.duration}s`,
                    }}
                />
            ))}
            <style jsx>{`
                @keyframes confetti-fall {
                    0% {
                        transform: translateY(0) rotate(0deg);
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(100vh) rotate(720deg);
                        opacity: 0;
                    }
                }
                .animate-confetti {
                    animation: confetti-fall linear forwards;
                }
            `}</style>
        </div>
    );
};

export default Confetti;
